import { dataHooks } from '@wix/data-hooks';

export const formQuizDataHooks = dataHooks<{
  main;
  inner;
  completeBtn;
  completeMsg;
  title;
}>('form-quiz');
